import { selfAxios } from "../../../../../axios/selfAxios.js";
async function opPostMatchCheckTypesSingle(params) {
  const res = await selfAxios.post(`/designapi/design/unifiedCheckApi/matchCheckTypesSingle`, params);
  return res.data;
}
export { opPostMatchCheckTypesSingle };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/unifiedCheckApi/matchCheckTypesSingle/post.js